import { useState } from "react";
import { Phone, Mail, Instagram, MessageCircle, Copy, Check } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, DEFAULT_WA_MSG, waLink } from "@/lib/site";

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copyMessage = async () => {
    try {
      await navigator.clipboard.writeText(DEFAULT_WA_MSG);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="contato" className="bg-[#111111] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight leading-[0.95] max-w-3xl">
          Precisa de guincho? <span className="text-[#FEFB0E]">Fale agora com a Brasil Transportes</span>
        </h2>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <a
            href={PHONE_TEL}
            data-testid="contact-phone-link"
            className="bg-[#171717] border border-white/10 rounded-md p-6 flex items-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#FEFB0E] focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <Phone className="w-8 h-8 text-[#FEFB0E] shrink-0" />
            <span>
              <span className="block text-xs uppercase tracking-widest text-neutral-500">Telefone / WhatsApp</span>
              <span className="block font-bold text-lg">{PHONE_DISPLAY}</span>
            </span>
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="contact-email-link"
            className="bg-[#171717] border border-white/10 rounded-md p-6 flex items-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#FEFB0E] focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <Mail className="w-8 h-8 text-[#FEFB0E] shrink-0" />
            <span className="min-w-0">
              <span className="block text-xs uppercase tracking-widest text-neutral-500">E-mail</span>
              <span className="block font-bold text-sm md:text-base break-all">{EMAIL}</span>
            </span>
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-link"
            className="bg-[#171717] border border-white/10 rounded-md p-6 flex items-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:border-[#FEFB0E] focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <Instagram className="w-8 h-8 text-[#FEFB0E] shrink-0" />
            <span>
              <span className="block text-xs uppercase tracking-widest text-neutral-500">Instagram</span>
              <span className="block font-bold text-lg">{INSTAGRAM_HANDLE}</span>
            </span>
          </a>
        </div>

        <div className="mt-10 bg-[#171717] border border-white/10 rounded-md p-6 md:p-8 max-w-3xl">
          <p className="text-xs uppercase tracking-widest text-neutral-500">Mensagem sugerida para agilizar</p>
          <p data-testid="contact-suggested-message" className="mt-3 text-neutral-300 text-sm md:text-base leading-relaxed">
            “{DEFAULT_WA_MSG}”
          </p>
          <button
            onClick={copyMessage}
            data-testid="copy-message-btn"
            className="mt-4 inline-flex items-center gap-2 border border-white/20 hover:border-[#FEFB0E] text-sm font-semibold uppercase tracking-wide px-4 py-2 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            {copied ? <Check className="w-4 h-4 text-[#50CF08]" /> : <Copy className="w-4 h-4" />}
            {copied ? "Copiado!" : "Copiar mensagem"}
          </button>
        </div>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-btn"
          className="mt-10 inline-flex w-full sm:w-auto items-center justify-center gap-3 bg-[#50CF08] hover:bg-[#42B006] text-white font-extrabold uppercase text-xl md:text-2xl px-10 py-5 rounded-md transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_40px_rgba(80,207,8,0.35)] focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
        >
          <MessageCircle className="w-7 h-7" />
          Chamar no WhatsApp
        </a>
      </div>
    </section>
  );
}
